export const SET_COURSE_MIGRATION_STATE = 'SET_COURSE_MIGRATION_STATE'
export const SET_COURSE_MIGRATION_STARTDATE = 'SET_COURSE_MIGRATION_STARTDATE'
export const SET_COURSE_MIGRATION_ENDDATE = 'SET_COURSE_MIGRATION_ENDDATE'
export const SET_COURSE_MIGRATION_INSTRUCTORS =
  'SET_COURSE_MIGRATION_INSTRUCTORS'
export const SET_COURSE_MIGRATION_CHECKED_EVENTS =
  'SET_COURSE_MIGRATION_CHECKED_EVENTS'
export const SET_COURSE_MIGRATION_ALL_EVENTS = 'SET_COURSE_MIGRATION_ALL_EVENTS'
